export { default } from './forgot-password-page';
